































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Fornecedor,
  FornecedoresService,
} from "@/services/fornecedores.service";
import Manter from "./Manter.vue";
import Loading from "@/shared/components/loading.vue";
import { LoginService } from "@/services/login.service";
import draggable from "vuedraggable";

const CHAVE_SEM_HOLDING = "sem-holding";

interface Grupo {
  chave: string;
  nome: string;
  legenda: string;
  holding: Fornecedor | null;
  filhos: Fornecedor[];
}

function legendaDe(ehHolding: boolean, qtd: number): string {
  const marcas = `${qtd} ${qtd === 1 ? "marca" : "marcas"}`;
  return ehHolding ? `Holding · ${marcas}` : `${marcas} fora de qualquer grupo`;
}

@Component({
  components: { Manter, Loading, draggable },
})
export default class Fornecedores extends Vue {
  term: string | null = null;
  somenteAtivos = false;
  fornecedores: Fornecedor[] = [];
  grupos: Grupo[] = [];
  // Guarda o que o usuario fechou, nao o que esta aberto: assim um grupo novo nasce
  // aberto e o estado sobrevive ao recarregamento apos cada arraste.
  colapsados: string[] = [];
  loading = false;
  // Os botoes usam v-permissao; esta flag existe porque arrastar tambem grava
  // (DefinirHolding) e precisa virar valor, no :disabled do draggable -- mesmo
  // arranjo de PlanosAba.vue. As funcoes sao as que o controller exige.
  podeCadastrar = false;

  mounted() {
    LoginService.GetRoleUsuario().then((funcoes) => {
      this.podeCadastrar = funcoes.indexOf("Admin") > -1 || funcoes.indexOf("Gerente") > -1;
    });

    this.fetchFornecedores();
  }

  // O texto filtra no cliente porque a arvore precisa do pai em maos: uma busca
  // server-side por "Eudora" traria a marca sem a holding dela, e o grupo nao teria
  // como ser montado.
  @Watch("term")
  onTermChange() {
    this.montarGrupos();
  }

  aberto(grupo: Grupo): boolean {
    return !this.colapsados.includes(grupo.chave);
  }

  alternar(grupo: Grupo) {
    this.colapsados = this.aberto(grupo)
      ? [...this.colapsados, grupo.chave]
      : this.colapsados.filter((x) => x !== grupo.chave);
  }

  async fetchFornecedores() {
    this.loading = true;
    try {
      this.fornecedores = await FornecedoresService.listarFornecedoresGlobais(
        null,
        this.somenteAtivos
      );
      this.montarGrupos();
    } finally {
      this.loading = false;
    }
  }

  montarGrupos() {
    const termo = (this.term || "").trim().toLowerCase();
    const casa = (f: Fornecedor) =>
      !termo || f.nome.toLowerCase().includes(termo);

    const holdings = this.fornecedores.filter((x) => x.ehHolding);
    const filhosDe = (idHolding: string | null) =>
      this.fornecedores.filter(
        (x) => !x.ehHolding && (x.idFornecedorHolding || null) === idHolding
      );

    const brutos = holdings.map((holding) => ({
      chave: holding.idFornecedor,
      nome: holding.nome,
      holding: holding as Fornecedor | null,
      filhos: filhosDe(holding.idFornecedor),
    }));

    brutos.push({
      chave: CHAVE_SEM_HOLDING,
      nome: "Sem holding",
      holding: null,
      filhos: filhosDe(null),
    });

    // A holding fica visivel quando ela mesma casa ou quando alguma marca dela casa,
    // senao a busca esconde o contexto do grupo.
    this.grupos = brutos
      .map((grupo) => {
        const holdingCasa = grupo.holding ? casa(grupo.holding) : false;
        const filhos = holdingCasa ? grupo.filhos : grupo.filhos.filter(casa);
        return {
          ...grupo,
          filhos,
          legenda: legendaDe(grupo.holding !== null, filhos.length),
        };
      })
      .filter(
        (grupo) =>
          !termo ||
          grupo.filhos.length > 0 ||
          (grupo.holding !== null && casa(grupo.holding))
      );
  }

  async onArrastar(evento: { added?: { element: Fornecedor } }, grupo: Grupo) {
    if (!evento.added) {
      return;
    }

    const fornecedor = evento.added.element;
    try {
      await FornecedoresService.definirHolding(
        fornecedor.idFornecedor,
        grupo.holding ? grupo.holding.idFornecedor : null
      );
    } catch {
      // O interceptor do axios ja exibiu a mensagem do servidor.
    } finally {
      // Sucesso ou erro, recarrega: o servidor e a verdade, e um erro tem de desfazer
      // o movimento em vez de deixar a tela mentindo sobre o que foi salvo.
      await this.fetchFornecedores();
    }
  }

  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novoFornecedor(false);
    this.fetchFornecedores();
  }

  async novaHolding() {
    const modal = this.$refs.manter as Manter;
    await modal.novoFornecedor(true);
    this.fetchFornecedores();
  }

  async editarFornecedor(fornecedor: Fornecedor) {
    const modal = this.$refs.manter as Manter;
    await modal.editarFornecedor(fornecedor.idFornecedor);
    this.fetchFornecedores();
  }
}
